import { ref } from 'vue'

/**
 * 内购ID手动修改锁定：用户手动改过内购ID后，不再根据商品信息自动拼接
 * @param getProdId 读取当前内购ID（连续创建会整体替换 settingForm，需用 getter）
 */
export default function useManualProdId(getProdId: () => string) {
  const isManualProdId = ref(false) // 内购ID是否被手动修改过，true 时不再自动拼接
  let prodIdBeforeFocus = '' // 内购ID获取焦点时的值

  // 内购ID获取焦点时，记录当前值
  const handleProdIdFocus = () => {
    prodIdBeforeFocus = getProdId()
  }

  // 内购ID失焦时，值发生改变说明用户手动修改过
  const handleProdIdBlur = () => {
    if (prodIdBeforeFocus !== getProdId()) {
      isManualProdId.value = true
    }
  }

  // 连续创建进入下一个商品时，恢复自动拼接
  const resetManualProdId = () => {
    isManualProdId.value = false
  }

  return { isManualProdId, handleProdIdFocus, handleProdIdBlur, resetManualProdId }
}
